// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetChildAwardTypesHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AwardTypeDTO from '../models/AwardTypeDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: null,
        },
        initValues);
    },
    id: 'id',
}

interface Result extends ResultDTO {
    childAwardTypes: AwardTypeDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            childAwardTypes: [],
        },
        initValues);
    },
    childAwardTypes: 'childAwardTypes',
}

export { Request, Result };